import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import TotalIncomeCard from '../Skeleton/TotalIncomeCard';
import PropTypes from 'prop-types';
import MainCard from "../MainCard";

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
}));

const TitleBar = ({ isLoading }) => {
    return (
        <>
            {isLoading ? (
                <TotalIncomeCard />
            ) : (
                <CardWrapper className="admin-topbar" border={false} content={false}>
                    <Box sx={{ p: 1, backgroundColor: '#f7f7f7' }}>
                        <Grid container spacing={2}>
                                <Grid item xs={6} alignItems="left">
                                        <Typography color='#000' align='left' sx={{ fontWeight:'700', fontSize: '2rem', fontWeight: 700, mt: 1.75 }}>
                                        Product Details
                                        </Typography>
                                    </Grid>

                        </Grid>
                    </Box>
                </CardWrapper>
            )}
        </>
    );
};

TitleBar.propTypes = {
    isLoading: PropTypes.bool
};

export default TitleBar;